
<template>
   <v-layout row wrap>

      <v-flex class="xs12 sm5">
         <user-list
            :title="'Utilisateurs'"
            :users="users"
            :selectedUserId="selectedUserId"
            @userSelected="userSelected"
            @addUser="addUser"
            @deleteUser="deleteUser"
         />
      </v-flex>

      <v-flex class="xs12 sm7">
         <router-view
            @deleteUser="deleteUser"
            @userFormChanged="selectedUserDirty = true"
            @userIdChanged="userIdChanged"
         ></router-view>
      </v-flex>

   </v-layout>
</template>


<script>
   import config from '@/config'
   const axios = require("axios")
   import UserList from '@/components/users/UserList'

   export default {

      components: {
         UserList: UserList,
      },

      mounted: function() {
         // fetch user list
         this.$store.dispatch('GET_USERS')
      },

      data () {
         return {
            selectedUserId: null,
            selectedUserDirty: false,
         }
      },

      computed: {
         users () {
            return Object.entries(this.$store.state.users).map(function([key, value]) {
               return value
            })
         },
      },

      methods: {
         userSelected (userId) {
            if (this.selectedUserDirty) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la création", color: 'red' })
            }
            // fetch user data for User component
            this.$store.dispatch('GET_USER', userId)
            this.selectedUserId = userId
            this.$router.push('/user-manager/user/' + userId)
         },
         addUser (user) {
            this.$router.push('/user-manager/create')
         },
         async deleteUser (userId) {
            this.$router.push('/user-manager')
            this.selectedUserId = null
            try {
               this.$store.commit('WAITING', true)
               await this.$store.dispatch('DELETE_USER', userId)
               this.$store.commit('SNACKBAR', { timeout: 1500, text: "Suppression effectuée", color: 'green' })
            } catch(err) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la suppression", color: 'red' })
            } finally {
               this.$store.commit('WAITING', false)
            }
         },

         userIdChanged (userId) {
            this.selectedUserId = userId
         },
      },
   };
</script>



// WEBPACK FOOTER //
// UsersManager.vue?7d73e946